// extracted by mini-css-extract-plugin
export var link = "_sj-0";